import axios from "axios";
import {
  CREATE_MODULE,
  DELETE_MODULE,
  FETCH_MODULE,
  FETCH_MODULES,
  FETCH_MODULES_FOR_SELECTOR,
  MODULE_ERROR,
  MODULE_SELECTOR_LOADING,
  SEARCH_MODULES,
  CLEAR_MODULE_SEARCH,
  UPDATE_MODULE,
} from "./types";

export const createModule = (payload) => async (dispatch) => {
  try {
    const data = await axios.post(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules`,
      payload,
    );
    return dispatch({
      type: CREATE_MODULE,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const setModuleError = (message) => (dispatch) => {
  return dispatch({
    type: MODULE_ERROR,
    payload: message,
  });
};

export const updateModule = (payload, moduleId) => async (dispatch) => {
  try {
    const data = await axios.patch(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules/${moduleId}`,
      payload,
    );

    return dispatch({
      type: UPDATE_MODULE,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const fetchModule = (moduleId) => async (dispatch) => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules/${moduleId}`,
    );
    const payload = data.data && data.data.data ? data.data.data : data.data || { name: "", description: "", videos: [] };
    dispatch({
      type: FETCH_MODULE,
      payload
    });
    return payload;
  } catch (error) {
    dispatch({
      type: MODULE_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
    throw error;
  }
};

export const fetchModules = ({ page = 1, perPage = 10 } = {}) => async (dispatch) => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules?page=${page}&perPage=${perPage}&timestamp=${new Date().getTime()}`,
    );
    return dispatch({
      type: FETCH_MODULES,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response
        ? error.response.data.error
        : error.message
          ? error.message
          : error.error,
    });
  }
};

export const fetchAllModules = () => async (dispatch) => {
  try {
    let allModules = [];
    let currentPage = 1;
    let hasMorePages = true;
    const perPage = 50; // Reasonable page size

    while (hasMorePages) {
      const response = await axios.get(
        `${process.env.REACT_APP_GOLANG_API}/api/v2/modules?page=${currentPage}&perPage=${perPage}&timestamp=${new Date().getTime()}`,
      );

      const { data, pagination } = response.data;
      
      if (data && Array.isArray(data)) {
        allModules = [...allModules, ...data];
      }

      // Check if there are more pages
      if (pagination && pagination.current < pagination.totalPages) {
        currentPage++;
      } else {
        hasMorePages = false;
      }
    }

    return dispatch({
      type: FETCH_MODULES,
      payload: {
        data: allModules,
        pagination: {
          current: 1,
          pageSize: allModules.length,
          total: allModules.length,
          totalPages: 1
        }
      },
    });
  } catch (error) {
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response
        ? error.response.data.error
        : error.message
          ? error.message
          : error.error,
    });
  }
};

export const deleteModule = (moduleId) => async (dispatch) => {
  try {
    const data = await axios.delete(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules/${moduleId}`,
    );

    return dispatch({
      type: DELETE_MODULE,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

// Module selector specific actions
export const fetchModulesForSelector = ({ page = 1, perPage = 20, search = "", append = false, signal } = {}) => async (dispatch) => {
  dispatch({ type: MODULE_SELECTOR_LOADING, payload: true });
  
  try {
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules?page=${page}&perPage=${perPage}${searchParam}&timestamp=${new Date().getTime()}`,
      { signal }
    );
    
    dispatch({ type: MODULE_SELECTOR_LOADING, payload: false });
    return dispatch({
      type: FETCH_MODULES_FOR_SELECTOR,
      payload: { ...data.data, append },
    });
  } catch (error) {
    dispatch({ type: MODULE_SELECTOR_LOADING, payload: false });
    
    // Don't dispatch error for cancelled requests
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      return;
    }
    
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response
        ? error.response.data.error
        : error.message
          ? error.message
          : error.error,
    });
  }
};

export const searchModules = (searchText, { page = 1, perPage = 20, append = false, signal } = {}) => async (dispatch) => {
  dispatch({ type: MODULE_SELECTOR_LOADING, payload: true });
  
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/modules?page=${page}&perPage=${perPage}&search=${encodeURIComponent(searchText)}&timestamp=${new Date().getTime()}`,
      { signal }
    );
    
    dispatch({ type: MODULE_SELECTOR_LOADING, payload: false });
    return dispatch({
      type: SEARCH_MODULES,
      payload: { ...data.data, append },
    });
  } catch (error) {
    dispatch({ type: MODULE_SELECTOR_LOADING, payload: false });
    
    // Don't dispatch error for cancelled requests
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      return;
    }
    
    return dispatch({
      type: MODULE_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const clearModuleSearch = () => (dispatch) => {
  dispatch({
    type: CLEAR_MODULE_SEARCH,
  });
};
